import TelecollectDetailSale from './TelecollectDetailSale'
export default TelecollectDetailSale
